import {
  BiChartViz,
  BiFunnelViz,
  BiVizSpec,
  BiVizType,
} from '@euler/model/bi/viz';

/**
 * How a chart card is shown: as its chart or as its result table. A view
 * state only — never saved to the card.
 */
export enum BiViewMode {
  Chart = 'chart',
  Table = 'table',
}

/** Whether the viz is a chart or a funnel, so it toggles to its table. */
export function biHasTableToggle(
  viz: BiVizSpec,
): viz is BiChartViz | BiFunnelViz {
  return viz.type !== BiVizType.Table && viz.type !== BiVizType.Kpi;
}
